import { request } from "../utils/request";
import { BACKEND_BASE_URL } from "./Resolver";

export type LogoutInfo = {
  logout_url: string;
};

export class Logout {
  public static async logout(): Promise<LogoutInfo> {
    const url = new URL(`${BACKEND_BASE_URL}/api/v1/logout`);
    const response = await request(
      url,
      { method: "POST", credentials: "include" },
      true,
      "Successfully logged out",
    );
    return await response.json();
  }
}
